var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view_box",class:_vm.isAni ? 'ani':''},[_c('img',{staticClass:"report_start_btn",attrs:{"src":require("@/assets/images/yearReport/btn_点击查看.png"),"alt":""},on:{"click":_vm.pageChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }